
import React, {FC} from 'react';
import Button from 'components/Button';

import CheckIcon from './svgs/check.inline.svg';

import * as styles from './styles.module.scss';

type ThankYouProps = {
	onClose: () => void
};

export const ThankYou: FC<ThankYouProps> = ({onClose}) => (
	<div className={styles.thankYou}>
		<CheckIcon />
		<h1>
			Thank you for your feedback!
		</h1>
		<Button variant='light' onClick={onClose}>
			Close
		</Button>
	</div>
);
